import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';
import api from '../api';
import { authConfig, parseAuthState } from '../api/auth';
import { Loading } from '../components';
import { useAppState, useNotification } from '../hooks';

const Page = styled(Flex)`
  width: 100%;
`;

function AuthRedirect({ history }) {
  const [params, setParams] = useState(new URLSearchParams(window.location.search));
  const { setAccountId } = useAppState();
  const { addNotification } = useNotification();

  useEffect(() => {
    setParams(new URLSearchParams(window.location.search));
  }, []);

  useEffect(() => {
    async function login() {
      try {
        const { accountId, path } = parseAuthState(params.get('state'));

        // Use , to parse out the accountId and pathFrom from state.
        // Change _ back to / since SSO API rejects /.
        const { autoConfigHoustonError } = await api.auth.login(accountId, params.get('code'), authConfig.redirectUri, authConfig.clientId);
        if (autoConfigHoustonError) {
          addNotification(
            autoConfigHoustonError,
            'error',
          );
        }
        localStorage.setItem('accountId', accountId);
        setAccountId(accountId);
        history.replace(path);
      } catch (error) {
        if (error?.response?.status === 403) {
          history.replace('/no-access');
        }
      }
    }

    login();
  }, [addNotification, history, setAccountId, params]);

  return (
    <Page alignItems="center" justifyContent="center">
      <Loading size={24} ml={2} />
    </Page>
  );
}

AuthRedirect.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AuthRedirect;
